// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.documents.LeaseDocumentsOuidWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid,
  LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid_Path,
  LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid,
  LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid_Path,
  LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid,
  LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  GetExplainerLeaseForLeaseFromOuidResponseDto,
  GetLandlordProvidedDocumentsFromOuidResponseDto,
  PreviewUrlFromOuidResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface GetExplainerLeaseFromOuidParams {
  ouid: string;
}
interface GetLandlordProvidedDocumentsFromOuidParams {
  ouid: string;
}
interface PreviewUrlFromOuidParams {
  ouid: string;
}

export type LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid_Options = UseQueryOptions<
  GetExplainerLeaseForLeaseFromOuidResponseDto,
  unknown,
  GetExplainerLeaseForLeaseFromOuidResponseDto,
  Array<string | GetExplainerLeaseFromOuidParams>
>;

const LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid_GetKey = (
  getParams: GetExplainerLeaseFromOuidParams,
) => [LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid_Path, getParams];

/**
 * get explainer lease file name associated with specific lease from ouid token
 */
export const useLeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid = (
  getParams: GetExplainerLeaseFromOuidParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid_GetKey(getParams),
    queryFn: () => LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid(getParams, httpClient),
  });
};
useLeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid.getKey =
  LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid_GetKey;

export type LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid_Options = UseQueryOptions<
  GetLandlordProvidedDocumentsFromOuidResponseDto,
  unknown,
  GetLandlordProvidedDocumentsFromOuidResponseDto,
  Array<string | GetLandlordProvidedDocumentsFromOuidParams>
>;

const LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid_GetKey = (
  getParams: GetLandlordProvidedDocumentsFromOuidParams,
) => [LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid_Path, getParams];

/**
 * get landlord provided document names from ouid token
 */
export const useLeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid = (
  getParams: GetLandlordProvidedDocumentsFromOuidParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid_GetKey(getParams),
    queryFn: () => LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid(getParams, httpClient),
  });
};
useLeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid.getKey =
  LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid_GetKey;

export type LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid_Options = UseQueryOptions<
  PreviewUrlFromOuidResponseDto,
  unknown,
  PreviewUrlFromOuidResponseDto,
  Array<string | PreviewUrlFromOuidParams>
>;

const LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid_GetKey = (getParams: PreviewUrlFromOuidParams) => [
  LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid_Path,
  getParams,
];

/**
 * get preview lease url from ouid token
 */
export const useLeaseDocumentsOuidWebApiHandler_previewUrlFromOuid = (
  getParams: PreviewUrlFromOuidParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid_GetKey(getParams),
    queryFn: () => LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid(getParams, httpClient),
  });
};
useLeaseDocumentsOuidWebApiHandler_previewUrlFromOuid.getKey =
  LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid_GetKey;
